export function ignoreModalConfirm(): void {
  // ignored
}

export function ignoreModalError(): void {
  // ignored
}

export function doNothing(): void {
  // ignored
}
